var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10,
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0659 6.98673C18.3436 6.70419 18.5 6.34459 18.5 5.96595C18.5 5.5959 18.3506 5.24403 18.0846 4.96452C17.5507 4.31421 16.5876 4.38296 16.0349 4.94517L8.17052 12.9449L4.963 9.75309C4.68557 9.4719 4.32903 9.31004 3.94961 9.31004C3.56924 9.31004 3.21186 9.47271 2.93414 9.75521C2.65638 10.0377 2.5 10.3973 2.5 10.776C2.5 11.1546 2.65638 11.5142 2.93414 11.7968L7.12019 16.0548C7.39791 16.3373 7.75529 16.5 8.13566 16.5C8.51603 16.5 8.87341 16.3373 9.15113 16.0548L18.0659 6.98673Z",
    fill: "#121212",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelected);
export default __webpack_public_path__ + "static/media/selected.5abdbd2c8006c05636b9f4743c754513.svg";
export { ForwardRef as ReactComponent };